// extracted by mini-css-extract-plugin
export var program = "Program-module--program--15j7L";
export var program__container = "Program-module--program__container--1TB2d";
export var program__title = "Program-module--program__title--1T2qK";
export var program__switchContainer = "Program-module--program__switchContainer--3hWQQ";
export var program__switch = "Program-module--program__switch--2NUrB";
export var program__switch_active = "Program-module--program__switch_active--3Zshh";
export var program__simpleCardConteiner = "Program-module--program__simpleCardConteiner--1wcW6";
export var program__textContent = "Program-module--program__textContent--1XXxo";
export var program__card = "Program-module--program__card--MZarU";